import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { api } from 'app/utils/constants'

import { AskResetPasswordPayload } from 'app/types/auth/login'

export const askResetPassword = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.auth.ASK_RESET_PASSWORD}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = AskResetPasswordPayload.safeParse(payload)

        // Wrong payload
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json(undefined, {
            status: StatusCodes.NO_CONTENT,
        })
    },
)
